import PropTypes from 'prop-types'
import React from 'react'

export default (Component) => {
  class RedirectableComponent extends React.Component {
    componentDidMount() {
      const orderState = this.props.order
      const orderForm =
        (orderState && orderState.orderForm) || this.props.orderForm

      this.redirectWhenMissingOrderFormProperty(orderForm)
    }

    componenDidUpdate(prevProps) {
      if (this.props.order !== prevProps.order) {
        const orderState = this.props.order
        const orderForm = orderState.orderForm
        const redirectRoute = this.getRedirectRoute(orderForm)

        if (redirectRoute) {
          this.props.router.push(redirectRoute)
        }
      }
    }

    redirectWhenMissingOrderFormProperty(orderForm) {
      const redirectRoute = this.getRedirectRoute(orderForm)

      if (redirectRoute) {
        this.props.router.push(redirectRoute)
      }

      return redirectRoute
    }

    checkClientProfileRedirect = (orderForm) => {
      return orderForm && !orderForm.clientProfileData ? '/' : null
    }

    checkItemsRedirect = (orderForm) => {
      return orderForm && orderForm.items && orderForm.items.length === 0
        ? '/cart'
        : null
    }

    getRedirectRoute = (orderForm) => {
      return (
        this.checkClientProfileRedirect(orderForm) ||
        this.checkItemsRedirect(orderForm)
      )
    }

    render() {
      return <Component {...this.props} />
    }
  }

  RedirectableComponent.propTypes = {
    router: PropTypes.any,
    order: PropTypes.object,
    orderForm: PropTypes.any,
  }

  return RedirectableComponent
}
